import React from 'react';
import { Modal, ModalProps } from 'antd';
import './index.less';

const CustomisedModal: React.FC<ModalProps> = (props) => {
  return <Modal {...props} />;
};

export default CustomisedModal;
